import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ConnectionPopupComponent } from '../../../shared/connection-popup/connection-popup.component';
import { PopupCustomProps } from '../../../shared/connection-popup/connection-popup.types';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  dialogRef: MatDialogRef<ConnectionPopupComponent, any>;

  constructor(private dialog: MatDialog) {}

  open(config: MatDialogConfig, data: PopupCustomProps): void {
    this.dialogRef = this.dialog.open(ConnectionPopupComponent, {
      // Default values
      width: '450px',
      disableClose: true,
      // Text in the Popup
      data,
      ...config
    } as MatDialogConfig);
  }

  close(): void {
    this.dialogRef.close();
  }
}
